module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cancel":"Cancel","update":"Update"}}')
  delete Component.options._Ctor
}
